import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchPagination, SearchResults } from '@uncinc/react-searchkit';

import EventCard from '../../../EventCard';
import hitTagMapper from '../../../SearchAllContent/helpers/hitTagMapper';
import { SearchTopicalEventHit } from '../../types';

const SearchTopicalResultsEvents: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchTopical__Results--Events');

  return (
    <div className={classNames}>
      <h2 className="mb-0">{t('components.search_topical.results.events')}</h2>

      <SearchResults
        renderItem={(hit: SearchTopicalEventHit) => {
          const themeTags = hit.theme?.[0] ? hitTagMapper(hit.theme, 'theme') : [];
          const typeTags = hit.event_type?.[0] ? hitTagMapper(hit.event_type, 'article-type') : [];
          const tags = themeTags.concat(typeTags);

          const firstUpcomingStartDate =
            hit.event_date[hit.computed_first_upcoming_date_index[0]];
          const firstUpcomingEndDate =
            hit.event_date_end_value[hit.computed_first_upcoming_date_index[0]];

          /**
           * Apend +00:00 to the date registration.
           * We do this because the dates we receive from the API are stored in UTC.
           * By appending +00:00 we can handle them as such.
           */
          const startDate = new Date(firstUpcomingStartDate ? `${firstUpcomingStartDate}+00:00` : '');
          const endDate = new Date(firstUpcomingEndDate ? `${firstUpcomingEndDate}+00:00` : '');

          return (
            <EventCard
              title={hit.page_title[0]}
              tags={tags}
              link={hit.url[0]}
              startDate={startDate}
              image={hit.image_style_uri?.[0]}
              endDate={endDate}
              hasMultipleDates={hit.event_date_infinite.includes(true) || hit.event_date.length > 1}
            />
          );
        }}
      />

      <div className="mt-4">
        <SearchPagination
          previousLabel={t('buttons.previous')}
          nextLabel={t('buttons.next')}
        />
      </div>
    </div>
  );
};

export default SearchTopicalResultsEvents;
